import React from 'react';

const RectangleIcon = ({ width = 50, height = 30, color = "black" }) => (
  <svg width={width} height={height}>
    <rect width="100%" height="100%" stroke={color} strokeWidth="3" fill="transparent" />
  </svg>
);

export default RectangleIcon;
